import { Space } from 'antd';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { useRouter } from 'next/router';
import styles from './SectionTab.module.css';

const cx = classNames.bind(styles);

interface ISectionTab {
  key: string;
  path: string;
  text: string;
  disabled?: boolean;
}
interface ISectionTabProps {
  tabList?: ISectionTab[];
}

function SectionTab({ tabList }: ISectionTabProps) {
  const router = useRouter();
  const { pathname } = router;

  return (
    <Space className={cx('wrapper')}>
      {tabList?.map(
        ({ key, path, text, disabled }) =>
          !disabled && (
            <Link key={key} href={path} passHref>
              <span
                className={cx({
                  text: true,
                  active: pathname.split('/')[2] === key,
                })}
              >
                {text}
              </span>
            </Link>
          )
      )}
    </Space>
  );
}

export default SectionTab;
